var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperDotComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "p6o712ftpa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.419608 0 0 0 0 0.356863 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-402 -109) translate(0 85) translate(402 24)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#006b5b",
    d: "M11.814 19.72c.204.138.506.083.65-.117l8.445-11.79c.075-.105.104-.233.085-.36-.02-.127-.086-.24-.193-.318l-2.776-2.043c-.079-.06-.18-.092-.279-.092-.2.026-.312.098-.387.2l-5.96 8.326c-.15.21-.44.263-.65.117l-5.097-3.46c-.08-.053-.17-.081-.264-.081-.16 0-.309.08-.397.213L3.08 13.207c-.069.106-.096.236-.07.365.024.123.097.236.201.306l8.603 5.842z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperDotComplete);
export default __webpack_public_path__ + "static/media/stepper-dot-complete.4040bf4ffb5f23c19011a856e782d5f1.svg";
export { ForwardRef as ReactComponent };